import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { getToken } from '@/utils/auth'
import { tansParams } from "@/utils/common";

let downloadLoadingInstance;


var dev = "http://192.168.124.166:9007";
var test = "https://www.ioofox.com:9007";
var pro = "https://halababyapp.halababy.com:9007";

// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: pro,
    // 超时
    timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    console.log(isToken)
    if (getToken() && !isToken) {
        config.headers['authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.status || 200;
    // 获取错误信息
    const msg = res.message || '未知错误'
    // 二进制数据则直接返回
    // if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
    //   return res.data
    // }
    if (code === 2401) {
        // if (!isRelogin.show) {
        //     isRelogin.show = true;
        //     MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        //     confirmButtonText: '重新登录',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //     }
        // ).then(() => {
        //     isRelogin.show = false;
        //     store.dispatch('LogOut').then(() => {
        //     location.href = '/index';
        //     })
        // }).catch(() => {
        //     isRelogin.show = false;
        // });
        // }
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code != 200) {
        Message({
            message: msg,
            type: 'error'
        })
        return Promise.reject(new Error(msg))
    } else if (code !== 200) {
        return Promise.reject('error')
    } else {
        return res.data
    }
},
    error => {
        console.log('err' + error)
        let { message } = error;
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js